import { render, staticRenderFns } from "./podcasts.vue?vue&type=template&id=51537ec6&"
import script from "./podcasts.vue?vue&type=script&lang=js&"
export * from "./podcasts.vue?vue&type=script&lang=js&"
import style0 from "./podcasts.vue?vue&type=style&index=0&id=51537ec6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports